<template>
  <div class="full_view hidden-sm-and-down">
    <svg height="100vh" width="100vw">
      <g class="from-top" style="animation-delay: 0s">
        <rect
          x="0"
          width="15%"
          height="100vh"
          style="
            fill: rgba(55, 56, 58, 0.9);
            stroke-width: 3;
            stroke: rgba(55, 56, 58, 0);
          "
        />
      </g>
      <g class="from-top-stay-right" style="animation-delay: 0s">
        <svg width="15%" x="0" height="100%">
          <text
            class="change-font responsive-size"
            x="50%"
            y="35%"
            fill="rgb(242,239,232)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            J
          </text>
        </svg>
      </g>
      <g class="from-bottom" style="animation-delay: 0s">
        <rect
          x="15%"
          width="9%"
          height="100vh"
          style="
            fill: rgba(242, 239, 232, 0.9);
            stroke-width: 3;
            stroke: rgba(55, 56, 58, 0);
          "
        />
      </g>
      <g class="from-bottom-stay-right" style="animation-delay: 0s">
        <svg width="9%" x="15%" height="100%">
          <!-- <rect
            width="100vw"
            height="100vh"
            style="fill: red; stroke-width: 3; stroke: rgba(55, 56, 58, 0)"
          /> -->
          <text
            class="change-font responsive-size"
            x="50%"
            y="35%"
            fill="rgb(23,101,179)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            A
          </text>
          <text
            class="change-font responsive-size"
            x="50%"
            y="60%"
            fill="rgb(55,56,58)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            T
          </text>
        </svg>
      </g>
      <g class="from-top" style="animation-delay: 0s">
        <rect
          x="24%"
          width="16%"
          height="100vh"
          style="
            fill: rgba(23, 101, 179, 0.9);
            stroke-width: 3;
            stroke: rgba(55, 56, 58, 0);
          "
        />
      </g>
      <g class="from-top-stay-right" style="animation-delay: 0s">
        <svg width="16%" x="24%" height="100%">
          <text
            class="change-font responsive-size"
            x="50%"
            y="35%"
            fill="rgb(55,56,58)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            Z
          </text>
          <text
            class="change-font responsive-size"
            x="50%"
            y="60%"
            fill="rgb(242,239,232)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            E
          </text>
        </svg>
      </g>
      <g class="from-bottom" style="animation-delay: 0s">
        <rect
          x="40%"
          width="10%"
          height="100vh"
          style="
            fill: rgba(242, 239, 232, 0.9);
            stroke-width: 3;
            stroke: rgba(55, 56, 58, 0);
          "
        />
      </g>
      <g class="from-bottom-stay-right" style="animation-delay: 0s">
        <svg width="10%" x="40%" height="100%">
          <text
            class="change-font responsive-size"
            x="50%"
            y="35%"
            fill="rgb(55,56,58)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            Z
          </text>
          <text
            class="change-font responsive-size"
            x="50%"
            y="60%"
            fill="rgb(23,101,179)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            R
          </text>
        </svg>
      </g>
      <g class="from-top" style="animation-delay: 0s">
        <rect
          x="50%"
          width="10%"
          height="100vh"
          style="
            fill: rgba(23, 101, 179, 0.9);
            stroke-width: 3;
            stroke: rgba(55, 56, 58, 0);
          "
        />
      </g>
      <g class="from-top-stay-right" style="animation-delay: 0s">
        <svg width="10%" x="50%" height="100%">
          <text
            class="change-font responsive-size"
            x="50%"
            y="60%"
            fill="rgb(55,56,58)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            D
          </text>
        </svg>
      </g>
      <g class="from-bottom" style="animation-delay: 0s">
        <rect
          x="60%"
          width="18%"
          height="100vh"
          style="
            fill: rgba(55, 56, 58, 0.9);
            stroke-width: 3;
            stroke: rgba(55, 56, 58, 0);
          "
        />
      </g>
      <g class="from-bottom-stay-right" style="animation-delay: 0s">
        <svg width="18%" x="60%" height="100%">
          <text
            class="change-font responsive-size"
            x="50%"
            y="60%"
            fill="rgb(242,239,232)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            A
          </text>
        </svg>
      </g>
      <g class="from-top" style="animation-delay: 0s">
        <rect
          x="78%"
          width="10%"
          height="100vh"
          style="
            fill: rgba(242, 239, 232, 0.9);
            stroke-width: 3;
            stroke: rgba(55, 56, 58, 0);
          "
        />
      </g>
      <g class="from-top-stay-right" style="animation-delay: 0s">
        <svg width="10%" x="78%" height="100%">
          <text
            class="change-font responsive-size"
            x="50%"
            y="60%"
            fill="rgb(55,56,58)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            Y
          </text>
        </svg>
      </g>
      <g class="from-bottom" style="animation-delay: 0s">
        <rect
          x="88%"
          width="12%"
          height="100vh"
          style="
            fill: rgb(23, 101, 179, 0.9);
            stroke-width: 3;
            stroke: rgba(55, 56, 58, 0);
          "
        />
      </g>
      <g class="from-bottom-stay-right" style="animation-delay: 0s">
        <svg width="12%" x="88%" height="100%">
          <text
            class="change-font responsive-size"
            x="50%"
            y="60%"
            fill="rgb(242,239,232)"
            font-family="'Teko', sans-serif"
            text-anchor="middle"
          >
            S
          </text>
        </svg>
      </g>
      <g class="show-sub-title">
        <text
          class=""
          x="90%"
          y="80%"
          fill="rgb(242,239,232)"
          font-size="4rem"
          text-anchor="end"
          font-family="'Teko', sans-serif"
        >
          Inszenierte Lesung mit Jazz
        </text>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "FirstView",
  computed: {
    getFontSize() {
      return "7vw";
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Fauna+One&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap");
@import "~vuetify/src/styles/settings/_variables.scss";

.full_view {
  // display: none;
  position: absolute;
  height: 100vh;
  width: 100vw;
  // border: 2px red solid;
  // background-color: white;
  z-index: 200;
}

/****************** Jazzterdays font properties **************************/

.responsive-size {
  font-size: 10vw;

  @media #{map-get($display-breakpoints, 'xl-only')} {
    font-size: 10vw;
  }

  @media #{map-get($display-breakpoints, 'lg-only')} {
    font-size: 12vw;
  }
  @media #{map-get($display-breakpoints, 'md-only')} {
    font-size: 12vw;
  }

  @media #{map-get($display-breakpoints, 'sm-only')} {
    font-size: 10vw;
  }
}

.change-font {
  animation-name: change-color;
  animation-duration: 10s;
  animation-delay: 5s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
}

@keyframes change-color {
  100% {
    // fill: #f2efe8;
    fill: #1765b3;
    opacity: 0.9;
    // stroke: #252323;
  }
}

.show-sub-title {
  animation-name: show-sub;
  animation-duration: 8s;
  animation-timing-function: ease-in-out;
  animation-delay: 8s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  opacity: 0;
}

@keyframes show-sub {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

// @keyframes grow-size {
//   0% {
//     transition: font-size 12s;
//   }

//   100% {
//     transition: font-size 12s;
//   }
// }

/****************** Jazzterdays Buchstaben animations **************************/

.from-top-stay-right {
  width: 100vw;
  height: 100vh;
  animation-name: shutter-in-top-stay;
  animation-duration: 8s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-direction: normal, normal;
  animation-fill-mode: none, forwards;
  opacity: 1;
}

@keyframes shutter-in-top-stay {
  0% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 0;
  }

  40% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 0;
  }
  50% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 1;
  }

  100% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 1;
  }
}

.from-bottom-stay-right {
  width: 100vw;
  height: 100vh;
  animation-name: shutter-in-bottom-stay;
  animation-duration: 8s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: none, forwards;
  opacity: 1;
}
@keyframes shutter-in-bottom-stay {
  0% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 0;
  }
  40% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 0;
  }
  50% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 1;
  }

  100% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 1;
    fill: white;
  }
}

/****************** Blue&White Boxes **************************/

.from-top {
  // display: none;
  width: 100vw;
  height: 100vh;
  animation-name: shutter-in-top;
  animation-duration: 8s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: none;
  opacity: 0;
}
@keyframes shutter-in-top {
  0% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 0;
  }
  40% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 0;
  }
  50% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 1;
  }

  90% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 1;
  }
  100% {
    -webkit-transform: rotateX(100deg);
    transform: rotateX(100deg);
    -webkit-transform-origin: top;
    transform-origin: top;
    opacity: 0;
  }
}

.from-bottom {
  // display: none;
  width: 100vw;
  height: 100vh;
  animation-name: shutter-in-bottom;
  animation-duration: 8s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: none;
  opacity: 0;
}

@keyframes shutter-in-bottom {
  0% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 0;
  }
  40% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 0;
  }
  50% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 1;
  }

  85% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 1;
  }
  100% {
    -webkit-transform: rotateX(-100deg);
    transform: rotateX(-100deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    opacity: 0;
  }
}
</style>